import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MasterDataService } from '../../../services/master-data.service';
import { masterCountryCode } from '../../../interfaces/masterData';

/**
 * unified phone number input box with country code prefixes
 */
@Component({
  selector: 'app-phone-number',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    CommonModule,
    MatAutocompleteModule,
  ],
  templateUrl: './phone-number.component.html',
  styleUrl: './phone-number.component.scss'
})
export class PhoneNumberComponent {

  /**
   * constructor
   * 
   * @param countryCodeService services that gets country codes
   */
  constructor(
    private masterDataService: MasterDataService,
  ) {}
  /**
   * list of all country codes with their number and shorthand
   */
  countryCodes!: masterCountryCode[];
  /**
   * list of displayed country codes when searching for a specific one
   */
  filteredcountryCodes: masterCountryCode[] = [];
  /**
   * parent pTicket formgroup
   * 
   * @param pct_countrycode needs this field to properly function
   */
  @Input() formGroup!: FormGroup;

  /**
   * retrieves all country codes from service
   */
  ngOnInit() {
    this.masterDataService.getMasterCountrycodeMockList().subscribe(countryCodes => {
      this.countryCodes = countryCodes;
      this.filteredcountryCodes = this.countryCodes;
      this.filteredcountryCodes=  this.filteredcountryCodes.sort((a, b) => a.cod_alpha2.localeCompare(b.cod_alpha2))

    });
  }

  /**
   * filters the countryCodes list by typing
   * 
   * @param event on filter input update the displayed list
   */
  filterKeywords(event: Event): void{
    const filterValue = (event.target as HTMLInputElement).value;
    this.filteredcountryCodes = this.countryCodes.filter(countrycode => countrycode.cod_alpha2.includes(filterValue) || countrycode.cod_countryname.includes(filterValue) || countrycode.cod_countrycode.includes(filterValue));
  }

  /**
   * adds a country code to the parent formgroups country code value
   * 
   * @param event on select a country code add it to the pTicket via FormGroup
   */
  selectKeyword(event: any): void {
    this.formGroup.patchValue({pct_countrycode : event.option.value})
  }
}
